var _tspan, _tspan2, _tspan3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCatalogue3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 336,
    height: 95.998,
    viewBox: "0 0 336 95.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10429",
    transform: "translate(-1380 -814)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 8704",
    width: 336,
    height: 80,
    rx: 16,
    transform: "translate(1380 814)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": "42 items selected",
    transform: "translate(1396 850)",
    style: {
      fontFamily: "Inter-SemiBold,Inter",
      fontWeight: 600,
      fill: "#0a243f",
      fontSize: 12
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "42 items")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 18
  }, "selected"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9358",
    transform: "translate(-16 165)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 8705",
    width: 156,
    height: 32,
    rx: 4,
    transform: "translate(1560 673)",
    style: {
      fill: "#015fe5"
    }
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": "ADD TO YOUR CATALOGUE",
    transform: "translate(1572 693)",
    style: {
      fontSize: 10,
      fontFamily: "Inter-SemiBold,Inter",
      fontWeight: 600,
      fill: "#fff"
    }
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ADD TO YOUR CATALOGUE")))), /*#__PURE__*/React.createElement("path", {
    d: "m90.193 17.936 28.389 9.764a1.792 1.792 0 0 1 1.122 2.287 1.735 1.735 0 0 1-1.034 1.077l-12.535 5.1-5.1 12.535a1.81 1.81 0 0 1-2.335 1.013 1.881 1.881 0 0 1-1.034-1.1l-9.76-28.389a1.793 1.793 0 0 1 1.122-2.287 1.763 1.763 0 0 1 1.165 0z",
    transform: "translate(1580.195 860.165)",
    style: {
      fill: "#2973f0"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogue3);
export default __webpack_public_path__ + "static/media/catalogue3.0c93ab5afec9f9b4478980422a2b92de.svg";
export { ForwardRef as ReactComponent };